import Stack from "@mui/material/Stack"

import TextInput from "@components/text_input"

import {
  PasswordFormData,
  useAccountPasswordPageContext
} from "@contexts/account/profile/password"
import styles from "./style"

export default function AccountProfilePasswordPage() {
  const { translate, control } = useAccountPasswordPageContext()
  return (
    <Stack sx={styles.containerWidth} gap={2} p={2}>
      <Stack gap={2}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1.5}>
          <TextInput<PasswordFormData>
            type="password"
            name="newPassword"
            control={control}
            label={translate("new_password")}
            placeholder="·············"
            required
          />
          <TextInput<PasswordFormData>
            type="password"
            name="confirmPassword"
            control={control}
            label={translate("confirm_new_password")}
            placeholder="·············"
            required
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
